import * as React from 'react';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { Loading } from './../Loading';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string | JSX.Element;
  confirmLabel?: string;
  cancelLabel?: string;
  closeLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  loadingMessage?: string;
  error?: string;
  success?: string;
}
export class ConfirmDialog extends React.Component<ConfirmDialogProps> {
  render() {
    const props = this.props;
    return (
      <Modal size="md" isOpen={props.isOpen} toggle={props.onCancel} keyboard={true}>
        <ModalHeader toggle={props.onCancel}>{props.title}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col">{props.message}</div>
          </div>
        </ModalBody>
        <ModalFooter>
          {!props.success && (
            <div>
              <Button color="secondary" onClick={props.onCancel} data-testid="confirmDialogSecondaryAction">
                {props.cancelLabel ? props.cancelLabel : 'Cancel'}
              </Button>{' '}
              <Button color="primary" type="submit" onClick={props.onConfirm} data-testid="confirmDialogPrimaryAction">
                {props.confirmLabel ? props.confirmLabel : 'Confirm'}
              </Button>
            </div>
          )}
          {props.success && (
            <Button color="primary" onClick={props.onCancel} data-testid="confirmDialogPrimaryAction">
              {props.closeLabel ? props.closeLabel : 'Close'}
            </Button>
          )}
        </ModalFooter>
        {props.error && (
          <div className="alert alert-danger" style={{ margin: 10 }}>
            {props.error}
          </div>
        )}
        {props.success && (
          <div className="alert alert-success" style={{ margin: 10 }}>
            {props.success}
          </div>
        )}
        {props.isLoading && (
          <div style={{ margin: 10 }}>
            <Loading message={props.loadingMessage} />
          </div>
        )}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/ConfirmDialog.tsx